import { useMutation, useQueryClient } from '@tanstack/react-query';
import { changePlan } from '@/services/subscription.service';
import { queryKeys } from '@/hooks/queries/keys';
import type { ChangePlanReq, SubscriptionDto } from '@/types/subscription';

export const useChangePlan = () => {
    const queryClient = useQueryClient();
    return useMutation<SubscriptionDto, unknown, ChangePlanReq>({
        mutationFn: changePlan,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.subscription.me() });
            queryClient.invalidateQueries({ queryKey: queryKeys.subscription.snapshot() });
            queryClient.invalidateQueries({ queryKey: queryKeys.subscription.payments() });
            queryClient.invalidateQueries({ queryKey: queryKeys.subscription.usage() });
            queryClient.invalidateQueries({ queryKey: queryKeys.subscription.changeHistory() });
        },
    });
};
